// extracted by mini-css-extract-plugin
export default {"AdminNavigation":"AdminNavigation_AdminNavigation__7dRIx","Link":"AdminNavigation_Link__86EB2"};